var React = require('react');

function PlayButtonSmall (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.4824 5.44489C12.1491 5.82979 12.1491 6.79204 11.4824 7.17694L2.48242 12.3731C1.81575 12.758 0.982421 12.2769 0.982421 11.5071L0.982422 1.11476C0.982422 0.344959 1.81575 -0.136165 2.48242 0.248735L11.4824 5.44489Z","fill":"#00AED9"}));
}

PlayButtonSmall.defaultProps = {"width":"12","height":"13","viewBox":"0 0 12 13","fill":"none"};

module.exports = PlayButtonSmall;

PlayButtonSmall.default = PlayButtonSmall;
